import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { updateOfferPartida } from "../../../api/offerPartida";
import { alertError, alertSuccess } from "../../../utils/logger";
import Editor from "../editor/Editor";
import LoadingDialog from "./LoadingDialog";
import { Autocomplete } from "@material-ui/lab";
import { TIPO_PARTIDA } from "../../../utils/constants";

function getEmptyOfferPartida() {
  return {
    oferta_id: null,
    revision_num: null,
    capitulo_id: null,
    partida_id: null,
    tipo_unidad: null,
    referencia: null,
    descripcion: null,
    concepto: null,

    unidades: null,
  };
}

const EditOfferPartidaDialog = (props) => {
  const { title, productTypes, open, setOpen, data, onSave } = props;

  const [loading, setLoading] = useState(false);

  const [offerPartida, setOfferPartida] = useState({
    ...getEmptyOfferPartida(),
    ...data,
  });

  useEffect(() => {
    if (open)
      setOfferPartida({
        ...getEmptyOfferPartida(),
        ...data,
      });
  }, [open]);

  const loggedUser = useSelector(
    (store) => store.authentication?.user,
    shallowEqual
  );

  function saveOfferPartida() {
    const validatePartida = () => {
      let error = "";

      if (!offerPartida?.descripcion) {
        error = "La descripción es obligatoria.";
      } else if (!offerPartida?.referencia) {
        error = "La referencia es obligatoria.";
      } else if (!offerPartida?.concepto) {
        error = "El concepto es obligatorio.";
      }

      if (error) {
        alertError({
          error: error,
        });
        return false;
      }

      return true;
    };

    if (!validatePartida()) {
      return;
    }
    if (offerPartida.def_tipo_impotacion_partida === 2)
      offerPartida.unidades = 1;

    let saveOfferPartida = {
      ...offerPartida,
    };

    setLoading(true);
    updateOfferPartida(
      saveOfferPartida?.partida_id,
      saveOfferPartida,
      loggedUser?.accessToken
    )
      .then((res) => {
        if (res.status === 204) {
          setLoading(false);
          alertSuccess({
            title: "¡Guardada!",
            customMessage: "Cambios guardados con éxito",
          });
          onSave();
          setOpen(false);
          setOfferPartida(getEmptyOfferPartida());
        }
      })
      .catch((error) => {
        setLoading(false);
        alertError({
          error: error,
          customMessage: "No se han podido guardar los cambios",
        });
      });
  }

  const handleChange = (element) => (event) => {
    if (
      element === "unidades" &&
      offerPartida.def_tipo_impotacion_partida === 2
    )
      setOfferPartida({ ...offerPartida, unidades: 1 });
    else setOfferPartida({ ...offerPartida, [element]: event.target.value });
  };

  const handleChangeEditor = (element, value) => {
    if (value?.trim() !== "") {
      setOfferPartida({ ...offerPartida, [element]: value });
    }
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth="md"
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="table-dialog"
        className="backdrop"
      >
        <DialogTitle id="table-dialog">{title}</DialogTitle>
        <DialogContent>
          <div className="row d-flex align-items-center">
            <div className="col-md-6">
              <TextField
                label="Descripción"
                value={offerPartida.descripcion}
                onChange={handleChange("descripcion")}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-md-6">
              <TextField
                label="Referencia"
                value={offerPartida.referencia}
                onChange={handleChange("referencia")}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>
          <div>Concepto *</div>
          <br />
          <Editor
            body={offerPartida?.concepto || ""}
            setBody={(new_body) => {
              handleChangeEditor("concepto", new_body);
            }}
            className="max-height"
            placeholder={"Introduce el concepto aquí..."}
          />
          <div className="row d-flex align-items-center justify-content-between">
            <div className="col-md-3">
              <Autocomplete
                id="autocomplete-tipo"
                disableClearable
                filterSelectedOptions
                options={TIPO_PARTIDA}
                getOptionLabel={(option) => option.label}
                value={
                  TIPO_PARTIDA?.find(
                    (x) => x.value === offerPartida?.def_tipo_impotacion_partida
                  ) || ""
                }
                onChange={(event, selected) => {
                  offerPartida?.def_tipo_impotacion_partida !== 2
                    ? setOfferPartida({
                        ...offerPartida,
                        def_tipo_impotacion_partida: selected
                          ? selected.value
                          : null,
                      })
                    : setOfferPartida({
                        ...offerPartida,
                        def_tipo_impotacion_partida: selected
                          ? selected.value
                          : null,
                        unidades: 1,
                      });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Tipo de Partida"
                    margin="normal"
                    variant="outlined"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    required
                  />
                )}
              />
            </div>
            {offerPartida.def_tipo_impotacion_partida > 0 && (
              <div className="col-md-3">
                {offerPartida.def_tipo_impotacion_partida === 1 ? (
                  <TextField
                    label="Coste/hora (€)"
                    value={offerPartida.def_mano_de_obra_subcontrata_coste}
                    onChange={handleChange(
                      "def_mano_de_obra_subcontrata_coste"
                    )}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        min: 0,
                      },
                    }}
                    type="number"
                    margin="normal"
                    variant="outlined"
                    required
                  />
                ) : (
                  <TextField
                    label="Coste  subcontrata"
                    value={offerPartida.subcontrata_coste}
                    onChange={handleChange("subcontrata_coste")}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      inputProps: {
                        min: 0,
                      },
                    }}
                    type="number"
                    margin="normal"
                    variant="outlined"
                    required
                  />
                )}
              </div>
            )}
            <div className="col-md-3">
              <TextField
                label="Tipo de Unidad"
                value={offerPartida.tipo_unidad}
                onChange={handleChange("tipo_unidad")}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined"
                required
              />
            </div>
            <div className="col-md-3">
              <TextField
                label="Cantidad"
                disabled={offerPartida.def_tipo_impotacion_partida === 2}
                value={
                  offerPartida.def_tipo_impotacion_partida === 2
                    ? 1
                    : offerPartida.unidades
                }
                onChange={handleChange("unidades")}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  inputProps: {
                    min: 0,
                  },
                }}
                type="number"
                margin="normal"
                variant="outlined"
                required
              />
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            className="mr-2"
            onClick={() => {
              setOpen(false);
              setOfferPartida(getEmptyOfferPartida());
            }}
            variant="outlined"
          >
            Cancelar
          </Button>
          <Button
            onClick={() => {
              saveOfferPartida();
            }}
            variant="outlined"
            color="primary"
          >
            Guardar
          </Button>
          <br />
        </DialogActions>
      </Dialog>
      <LoadingDialog open={loading} />
    </>
  );
};
export default EditOfferPartidaDialog;
